import { Classes, Dialog, DialogProps } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
import CustomButton from "../CustomButton"
import styles from "./styles.module.scss"
/*
Props
1) rounded - specifies the corners are rounded or not
2) light - specifies the theme of the modal
3) width - specfies the width of the modal
4) headerPosition - specfies the position of header element
5) scrollbar - specifies whether to display the scrollbar or not

DialogFooter

props
1) isCloseButtonShown - specifies whether to show a close button in the footer ( default is false)
2) rightButton - specifies the right button
3) showDivider - specifies whether to show the divider between the actual content and the footer
*/

interface DialogFooterProps {
  footerShowCloseButton?: boolean
  footerClassName?: string
  footerRightButton?: any
  onClose:
    | ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void)
    | undefined
}

const DialogFooter = ({
  footerShowCloseButton = true,
  footerClassName,
  footerRightButton,
  onClose,
}: DialogFooterProps) => {
  return (
    <div className={classNames(Classes.DIALOG_FOOTER, footerClassName)}>
      <div className="flex justify-end items-center">
        {footerShowCloseButton && (
          <CustomButton
            className={footerRightButton ? "mr-3" : ""}
            icon="cross"
            text="Close"
            onClick={onClose}
          />
        )}
        {footerRightButton ? footerRightButton : null}
      </div>
    </div>
  )
}

export interface CustomDialogProps extends DialogProps {
  fixedHeader?: boolean
  scrollbar?: boolean
  scrollable?: boolean
  light?: boolean
  width?: string | number | undefined
  rounded?: boolean
  footer?: React.FC
  footerClassName?: string
  footerRightButton?: any
  footerShowCloseButton?: boolean
  footerShowDivider?: boolean
  /**
   * GrassUI Styles
   */
  grassUi?: boolean
}
const CustomDialog = ({
  className,
  isOpen,
  style,
  fixedHeader,
  scrollbar,
  scrollable,
  light,
  width,
  children,
  rounded,
  footer,
  footerClassName,
  footerRightButton,
  footerShowCloseButton,
  footerShowDivider = true,
  onClose,
  onOpened,
  grassUi,
  ...otherDialogProps
}: CustomDialogProps) => {
  return (
    <Dialog
      style={{
        width,
        ...style,
      }}
      {...otherDialogProps}
      className={classNames(
        styles.base,
        light && styles.light,
        rounded && styles.rounded,
        scrollbar && styles.hideScrollbar,
        fixedHeader && styles.fixedHeader,
        scrollable && styles.scrollable,
        grassUi && styles.grass,
        className
      )}
      isOpen={isOpen}
      onClose={onClose}
      onOpened={onOpened}
    >
      <div className={Classes.DIALOG_BODY}>{children}</div>
      {footerShowDivider && <hr className="my-0" />}
      {footer ? (
        footer
      ) : footerRightButton || footerShowCloseButton || footerShowDivider ? (
        <DialogFooter
          footerClassName={footerClassName}
          footerRightButton={footerRightButton}
          footerShowCloseButton={footerShowCloseButton}
          onClose={onClose}
        />
      ) : null}
    </Dialog>
  )
}

CustomDialog.defaultProps = {
  rounded: true,
  scrollbar: true,
  scrollable: true,
}
export default CustomDialog
